// Global function to equalize heights (defined early so it's available)
window.equalizeProductThumbSliders = function() {
  const thumbSliders = document.querySelectorAll('.product-thumb-slider');
  if(thumbSliders.length === 0) return;
  
  const thumbnailSliders = document.querySelectorAll('.thumbnail-slider');
  
  // Reset heights
  thumbSliders.forEach(slider => {
    slider.style.height = 'auto';
    slider.style.minHeight = 'auto';
  });
  
  thumbnailSliders.forEach(slider => {
    slider.style.height = 'auto';
    slider.style.minHeight = 'auto';
  });
  
  // Force reflow
  if(thumbSliders[0]) thumbSliders[0].offsetHeight;
  
  // Calculate max height
  let maxHeight = 0;
  thumbSliders.forEach(slider => {
    const slickList = slider.querySelector('.slick-list');
    if(slickList) {
      const height = slickList.offsetHeight || slider.offsetHeight;
      if(height > maxHeight) maxHeight = height;
    } else {
      const height = slider.offsetHeight;
      if(height > maxHeight) maxHeight = height;
    }
  });
  
  thumbnailSliders.forEach(slider => {
    const height = slider.offsetHeight;
    if(height > maxHeight) maxHeight = height;
  });
  
  // Apply max height
  if(maxHeight > 0) {
    thumbSliders.forEach(slider => {
      slider.style.height = maxHeight + 'px';
      slider.style.minHeight = maxHeight + 'px';
      const slickList = slider.querySelector('.slick-list');
      if(slickList) {
        slickList.style.height = maxHeight + 'px';
        slickList.style.minHeight = maxHeight + 'px';
      }
    });
    
    thumbnailSliders.forEach(slider => {
      slider.style.height = maxHeight + 'px';
      slider.style.minHeight = maxHeight + 'px';
    });
  }
};

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.checkoutBtn = this.querySelector('[name="custom_checkout"]');
      this.checkoutBtnMob = this.querySelector('[name="custom_checkout-mob"]');
      this.notifyBtn = document.querySelector('.notify_me_btn.submit_btn');
      this.form.querySelector('[name=id]').disabled = false;

      this.onSubmitHandler = this.onSubmitHandler.bind(this);
      this.handleCheckoutBtn = this.handleCheckoutBtn.bind(this);
      this.handleBackInStockAlert = this.handleBackInStockAlert.bind(this);

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.isQuickview = this.closest('[data-quickview-modal]') ? true : false;
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.initSlider();
      this.mobSlider();
      this.initZoom();
      this.initGeneralEvents();
      this.initImageLoadHandler();
    }

    connectedCallback(){}

    disconnectedCallback(){
      if(this.form) this.form.removeEventListener('submit', this.onSubmitHandler);
      if(this.checkoutBtn) this.checkoutBtn.removeEventListener('click', this.handleCheckoutBtn);
      if(this.notifyBtn) this.notifyBtn.removeEventListener('click', this.handleBackInStockAlert);

      if(this.checkoutBtnMob) this.checkoutBtnMob.removeEventListener('click', this.handleCheckoutBtn);
      // const qv = this.closest('.quickview-tpl');
      if(!this.isQuickview) return;
      if(jQuery('.product-main-slider.product__media-list').hasClass('slick-initialized')){
        jQuery('.product-main-slider.product__media-list').slick('unslick');
      }
      if(jQuery('.product-thumb-slider').length && jQuery('.product-thumb-slider').hasClass('slick-initialized')){
        jQuery('.product-thumb-slider').slick('unslick');
      }
      // if(jQuery.fancybox) jQuery.fancybox.destroy();
      jQuery('.product-main-slider [data-zoom]').trigger('zoom.destroy');
    }

    initGeneralEvents(){
      if(this.form) this.form.addEventListener('submit', this.onSubmitHandler);
      if(this.checkoutBtn) this.checkoutBtn.addEventListener('click', this.handleCheckoutBtn);
      if(this.checkoutBtnMob) this.checkoutBtnMob.addEventListener('click', this.handleCheckoutBtn);

      setTimeout(() => {
        this.notifyBtn = document.querySelector('.notify_me_btn.submit_btn');
        if(this.notifyBtn) this.notifyBtn.addEventListener('click', this.handleBackInStockAlert);
      }, 1000);

      const h5Elems = document.querySelectorAll('.product__accordion-main .desc1 .accordion__content.rte h5');
      const accElems = document.querySelectorAll('.product__accordion-main .acc-desc');
      for(let i=0; i<accElems.length; i++){
        accElems[i].addEventListener('click',(e)=>{
              let closestSummary = e.target.closest('summary')
              closestSummary.classList.toggle('expanded')
              closestSummary.classList.contains('expanded')?closestSummary.setAttribute('aria-expanded',true) : closestSummary.setAttribute('aria-expanded',false);
        })
      }
      h5Elems.forEach(function(item){
        item.setAttribute('role', 'heading');
        item.setAttribute('aria-level', '3');
      });
    }

    handleBackInStockAlert(){
      let hasError = false;
      let msg = '';
      const error = document.querySelector('.product_alert_signup_modal .error');
      error.style.display = 'none';
      var productSKU = document.getElementById('txtProductSKU').value;
      var emailInput = document.getElementById('txtEmailAddress');
      var emailAddress = emailInput.value;
      var alertCode = document.getElementById('hdnAlertCode').value;
      var checkbox = document.querySelector('.product_alert_signup_modal input#alert_check');
      if(emailAddress === ''){
        hasError = true;
        msg = 'Email edit field is required';
      } else {
        const regex = /^\S+@\S+\.\S+$/;
        if(!regex.test(emailAddress)){
          hasError = true;
          msg = 'Please enter a valid email address';
        }
      }

      if(!hasError){
        _ltk.Alerts.AddAlert(emailAddress, productSKU, alertCode);
        _ltk.Alerts.Submit();
        _theme.track.trackData({'event': 'notifyMeFormSubmitted'});
        emailInput.value = " "
        alert('Thank you! We will notify you when this product becomes available.');
        if(document.querySelector('.product_alert_signup_wrapper')) document.querySelector('.product_alert_signup_wrapper').classList.add('hide');
      } else{
        error.innerHTML="";
        const newSpan = document.createElement("span");
        newSpan.setAttribute("role", "alert")
        newSpan.textContent = msg;
        error.appendChild(newSpan)
        error.style.display = 'block';
        emailInput.focus();
      }
    }

    mobSlider(){
      const $sssSlider = jQuery('.sss');
      
      // Check if the element exists before initializing Slick
      if(!$sssSlider.length) return;

      $sssSlider.slick({ dots: true, arrows:false});

      $sssSlider.on('init', function(event, slick, currentSlide, nextSlide){
        run(slick.$slider);
      });

      $sssSlider.on('afterChange', function(event, slick, currentSlide, nextSlide){
        run(slick.$slider, currentSlide);
      });
      
      function run($slider, currentSlide){
        setTimeout(() => {
          // $slider.find('.slick-dots').attr('role', 'group');
          $slider.find('.slick-dots > li').each(function(index, item){
            jQuery(this).attr('data-slick-index', (index+1));
            const $btn = $(this).find('button');
            $btn.removeAttr('role tabindex').attr('aria-label','Slide ' +jQuery(this).attr('data-slick-index'));
          });

          if(currentSlide) $slider.find('.slick-dots > li[data-slick-index="'+currentSlide+'"]')[0].focus();
        }, 100);
      }
    }

    initSlider(){
      // const isQuickview = this.isQuickview || document.querySelector('.quickview-tpl');
      let isQuickview = jQuery('body.template-product').length ? false : true;
      buildSlider();
      setTimeout(buildSlider, 1000);

      function buildSlider(){
        const $mainSlider = jQuery('.product__media-gallery .product-main-slider');
        const $thumbSlider = jQuery('.product__media-gallery .product-thumb-slider');

        const quicvkViewSliderArrows = document.querySelector('.quickview-tpl .product-main-slider') ? true : false;
        if(quicvkViewSliderArrows){
          isQuickview = true;
        }
          $mainSlider.each(function(e){

            if($(this).hasClass('slick-initialized')){
              $(this).slick('unslick');
            }

            $(this).slick({
              accessibility: false,
              fade: true,
              asNavFor: jQuery('.product__media-gallery .product-thumb-slider').length > 0 ? '.product__media-gallery .product-thumb-slider' : null,
              infinite:false,
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
              arrows: isQuickview,
              responsive : [ { breakpoint: 992, settings: { slidesToShow: 1, slidesToScroll: 1}}],
              prevArrow:"<button tabindex='-1' type='button' aria-label='previous product image' class='toolTipToggle slick-arrow slick-prev'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''><span class='sr-only'>Previous</span></button>",
              nextArrow:"<button tabindex='0' type='button' aria-label='next product image' class='toolTipToggle slick-arrow slick-next'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''><span class='sr-only'>Next</span></button>",
            });
          })
        
        $mainSlider.on('init', function(event, slick, currentSlide, nextSlide){
          // _theme.initTooltip();
          slick.$slider.find('button.slick-arrow').attr('tabindex', 0);
          slick.$slider.find('button.slick-arrow[aria-disabled="true"]').attr('tabindex', -1);
        });

        $mainSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
          slick.$slider.find('button.slick-arrow').attr('tabindex', 0);
          slick.$slider.find('button.slick-arrow[aria-disabled="true"]').attr('tabindex', -1);
        });

        $mainSlider.on('afterChange', function(event, slick, currentSlide, nextSlide){
          slick.$slider.find('button.slick-arrow').attr('tabindex', 0);
          slick.$slider.find('button.slick-arrow[aria-disabled="true"]').attr('tabindex', -1);
          setTimeout(_theme.initSlickBtnEvent, 300);
        });

     

        if($thumbSlider.length === 0) return;

        if($thumbSlider.hasClass('slick-initialized')) $thumbSlider.slick('unslick');

        $thumbSlider.on('init', function(event, slick, currentSlide, nextSlide){
          // _theme.initTooltip();

          slick.$slider.find('.slick-slide').off('keyup').on('keyup', function(evt){
            if(evt.code && evt.code.toUpperCase() === 'ENTER') jQuery(evt.target).trigger('click');
          });

          slick.$slider.find('button.slick-arrow').attr('tabindex', 0);
          slick.$slider.find('button.slick-arrow[aria-disabled="true"]').attr('tabindex', -1);
          
          // Equalize heights after initialization
          setTimeout(() => {
            this.equalizeThumbSliderHeights();
          }, 300);
        }.bind(this));

        $thumbSlider.on('afterChange', function(event, slick, currentSlide, nextSlide){
          slick.$slider.find('button.slick-arrow').attr('tabindex', 0);
          slick.$slider.find('button.slick-arrow[aria-disabled="true"]').attr('tabindex', -1);

          slick.$slider.find('.slick-slide[aria-hidden="false"]').attr('tabindex', 0);

          setTimeout(function(){
            slick.$slider.find('.slick-slide[aria-hidden="false"]').attr('tabindex', 0);
          }, 50);
          setTimeout(function(){
            slick.$slider.find('.slick-slide[aria-hidden="false"]').attr('tabindex', 0);
            jQuery('#product-gallery-sr-only').text('Image loaded successfully');
          }, 100);

          setTimeout(()=>{
            if((slick.$slider.find('.slick-prev.slick-disabled')).length){
              jQuery('.product-thumb-slider button.thumbnail-list__item')[0].focus()
            }
          },600)

          setTimeout(()=>{
            if((slick.$slider.find('.slick-next.slick-disabled')).length){
              jQuery('.product-thumb-slider button.thumbnail-list__item')[jQuery('.product-thumb-slider button.thumbnail-list__item').length-1].focus()
            }
          },600)
         
          setTimeout(() => {
            jQuery('#product-gallery-sr-only').text('');
          }, 300);
          
          // Equalize heights after slide change
          setTimeout(() => {
            this.equalizeThumbSliderHeights();
          }, 100);
        }.bind(this));

        $thumbSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
          slick.$slider.find('button.slick-arrow').attr('tabindex', 0);
          slick.$slider.find('button.slick-arrow[aria-disabled="true"]').attr('tabindex', -1);
        });

        $thumbSlider.slick({
          asNavFor: jQuery('.product__media-gallery .product-main-slider').length > 0 ? '.product__media-gallery .product-main-slider' : null,
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical:true,
          infinite:false,
          dots: false,
          focusOnSelect: true,
          verticalSwiping:true,
          arrows: true,
          accessibility: true,
          prevArrow:"<button tabindex='-1' type='button' aria-label='click to view previous image' class='toolTipToggle slick-arrow slick-prev'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''><span class='sr-only'>Previous</span></button>",
          nextArrow:"<button tabindex='0' type='button' aria-label='click to view next image' class='toolTipToggle slick-arrow slick-next'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''><span class='sr-only'>Next</span></button>"
        });
        
        // Equalize heights after slider is created
        setTimeout(() => {
          this.equalizeThumbSliderHeights();
        }, 500);
      }
    }

    equalizeThumbSliderHeights(){
      // Use the global function to ensure all sliders are equalized
      if(typeof window.equalizeProductThumbSliders === 'function') {
        window.equalizeProductThumbSliders();
      } else {
        // Fallback if global function not yet available
        const thumbSliders = document.querySelectorAll('.product-thumb-slider');
        if(thumbSliders.length === 0) return;
        
        const thumbnailSliders = document.querySelectorAll('.thumbnail-slider');
        
        thumbSliders.forEach(slider => {
          slider.style.height = 'auto';
          slider.style.minHeight = 'auto';
        });
        
        thumbnailSliders.forEach(slider => {
          slider.style.height = 'auto';
          slider.style.minHeight = 'auto';
        });
        
        if(thumbSliders[0]) thumbSliders[0].offsetHeight;
        
        let maxHeight = 0;
        thumbSliders.forEach(slider => {
          const slickList = slider.querySelector('.slick-list');
          if(slickList) {
            const height = slickList.offsetHeight || slider.offsetHeight;
            if(height > maxHeight) maxHeight = height;
          } else {
            const height = slider.offsetHeight;
            if(height > maxHeight) maxHeight = height;
          }
        });
        
        thumbnailSliders.forEach(slider => {
          const height = slider.offsetHeight;
          if(height > maxHeight) maxHeight = height;
        });
        
        if(maxHeight > 0) {
          thumbSliders.forEach(slider => {
            slider.style.height = maxHeight + 'px';
            slider.style.minHeight = maxHeight + 'px';
            const slickList = slider.querySelector('.slick-list');
            if(slickList) {
              slickList.style.height = maxHeight + 'px';
              slickList.style.minHeight = maxHeight + 'px';
            }
          });
          
          thumbnailSliders.forEach(slider => {
            slider.style.height = maxHeight + 'px';
            slider.style.minHeight = maxHeight + 'px';
          });
        }
      }
    }

    initImageLoadHandler(){
      // Equalize heights when images finish loading
      const thumbSliders = document.querySelectorAll('.product-thumb-slider');
      if(thumbSliders.length === 0) return;
      
      const images = document.querySelectorAll('.product-thumb-slider img');
      let loadedCount = 0;
      const totalImages = images.length;
      
      if(totalImages === 0) {
        // If no images found, equalize immediately
        setTimeout(() => {
          this.equalizeThumbSliderHeights();
        }, 500);
        return;
      }
      
      images.forEach(img => {
        if(img.complete) {
          loadedCount++;
          if(loadedCount === totalImages) {
            setTimeout(() => {
              this.equalizeThumbSliderHeights();
            }, 500);
          }
        } else {
          img.addEventListener('load', () => {
            loadedCount++;
            if(loadedCount === totalImages) {
              setTimeout(() => {
                this.equalizeThumbSliderHeights();
              }, 500);
            }
          });
          // Also handle error case
          img.addEventListener('error', () => {
            loadedCount++;
            if(loadedCount === totalImages) {
              setTimeout(() => {
                this.equalizeThumbSliderHeights();
              }, 500);
            }
          });
        }
      });
    }

    initZoom(){
      if(jQuery('[data-zoom]').length && _theme.isLaptopAndUp){
        jQuery('[data-zoom]').trigger('zoom.destroy');
        setTimeout(function(){
          jQuery('[data-zoom]').zoom({ magnify: 1.05 });
        }, 500);

        window.onresize = debounce(function(event){
          jQuery('[data-zoom]').trigger('zoom.destroy');
          if(_theme.isLaptopAndUp){
            jQuery('[data-zoom]').zoom({ magnify: 1.05 });
          }
          // Equalize heights on resize
          this.equalizeThumbSliderHeights();
        }.bind(this), 500);
      }
    }

    handleCheckoutBtn(evt){
      evt.preventDefault();

      let gwpAutoEnable = false, gwpAutoThreshold = null, gwpAutoVid = null;
      if(_theme.gwpConfig.gwp_auto && _theme.gwpConfig.gwp_auto.enable){
        gwpAutoEnable = true;
        gwpAutoThreshold = Number(_theme.gwpConfig.gwp_auto.threshold);
        gwpAutoVid = _theme.gwpConfig.gwp_auto.vid;
      }

      this.checkoutBtn.setAttribute('aria-disabled', true);
      _theme.toggleLoading(1);
      if(this.checkoutBtnMob) {
        this.checkoutBtnMob.setAttribute('aria-disabled', true);
        this.checkoutBtnMob.classList.add('loading');
      }
      this.checkoutBtn.classList.add('loading');
      
      this.onSubmitHandler(evt, function(){
        if(gwpAutoEnable && gwpAutoThreshold && gwpAutoVid){
          _theme.toggleLoading(1);
          Shopify.getCart(function(cart){
            _theme.toggleLoading(1);
            const hasFreeGift = cart.items.some(item => item?.properties?._proType === 'freeGift');
            const cart_total_amt = cart.total_price / 100;
            if(!hasFreeGift && cart_total_amt >= gwpAutoThreshold){
              _theme.Helpers.addProductToCart(gwpAutoVid,1, 'freeGift', checkoutCB);
            }
          })
        } else {
          checkoutCB();
        }
      });

      function checkoutCB(){
        _theme.toggleLoading();
        window.location.href = '/checkout';
      }
    }

    onSubmitHandler(evt, callback) {
      evt.preventDefault();
      _theme.toggleLoading(1);
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.isQuickview = this.closest('[data-quickview-modal]') ? true : false;
      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', 'gwp,minicart');
      formData.append('sections_url', window.location.pathname);

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      this.updateATCAccessibilityStatus('in-progress');

      if(this.isQuickview){
        try {
          const variantObj = JSON.parse(this.querySelector('[data-variant-track]').textContent);
          const variantData = variantObj[formData.get('id')];
          if(variantData) _theme.track.trackQuickView(variantData);
        } catch (error) {
          console.log('Error while sending quickview ATC event')
        }
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            this.updateATCAccessibilityStatus('error', response.description);
            return;
          }

          _theme.initListrakCartUpdateEvent();

          if(callback && typeof callback === 'function'){
            callback()
          } else {
            this.updateATCAccessibilityStatus('done');
            _theme.MiniCart.lineItemChangeCallBack(response, () => {
              if(this.isQuickview) jQuery('[data-quickview-modal]').fadeOut();
              _theme.toggleSideCart(1, this.submitButton, true);
            });
          }

          this.error = false;
        }).catch((e) => {
          console.error(e);
        }).finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
         _theme.toggleLoading();
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    updateATCAccessibilityStatus(status, msg){
      const ariaElem = this.querySelector('#pdp-atc-status');
      if(!ariaElem || !status) return;
      switch(status){
        case 'in-progress':
          ariaElem.textContent = 'Adding';
          break;
        case 'done':
          ariaElem.textContent = 'Item added to your cart';
          break;
        case 'error':
          ariaElem.textContent = msg || 'Something went wrong';
          break;
        default:
          ariaElem.textContent = '';
      }

      setTimeout(() => {
        ariaElem.textContent = '';
      }, 3000);
    }

  });
}


// Call equalization on DOM ready and window load
document.addEventListener('DOMContentLoaded', function(){
  setTimeout(() => {
    if(typeof window.equalizeProductThumbSliders === 'function') {
      window.equalizeProductThumbSliders();
    }
  }, 1500);
});

window.addEventListener('load', function(){
  window.$ = window.jQuery;
  
  // Equalize thumb slider heights on page load
  setTimeout(() => {
    if(typeof window.equalizeProductThumbSliders === 'function') {
      window.equalizeProductThumbSliders();
    }
  }, 1500);
});

// Also call on window resize
let resizeTimeout;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    window.equalizeProductThumbSliders();
  }, 300);
});